type CacheItem<T> = {
  value: T
  expiresAt: number
}

export class SimpleCache<T> {
  private readonly cache: Map<string, CacheItem<T>> = new Map()

  private readonly ttl: number

  constructor(ttl: number) {
    this.ttl = ttl
  } // ttl в миллисекундах

  set(key: string, value: T): void {
    const expiresAt = Date.now() + this.ttl
    this.cache.set(key, { value, expiresAt })
  }

  get(key: string): T | null {
    const item = this.cache.get(key)

    if (!item) {
      return null
    } // Ключ отсутствует
    if (Date.now() > item.expiresAt) {
      // Ключ устарел
      this.cache.delete(key)
      return null
    }

    return item.value // Возвращаем значение
  }

  delete(key: string): void {
    this.cache.delete(key)
  }

  clear(): void {
    this.cache.clear()
  }

  size(): number {
    return this.cache.size
  }
}
